






























































































import Vue from 'vue';
// Service
import SchoolEventService, { SchoolEvent, SchoolEventUser } from '~/services/SchoolEventService';

// Components
import MainLayout from '../../components/layouts/mainlayout/MainLayout.vue';
import SchoolEventRegisteredModal from './SchoolEventRegisteredModal.vue';

export default Vue.extend({
    name: 'SchoolEventPage',
    components: {
        MainLayout,
        SchoolEventRegisteredModal,
    },
    data: () => ({
        schoolEventId: undefined as string | undefined,
        schoolEvent: {} as SchoolEvent,
        mySchoolEvents: [] as SchoolEventUser[],
        loading: true,
        service: new SchoolEventService(),
        showRegisteredModal: false as boolean,
    }),
    computed: {
        startTime(): string {
            return this.schoolEvent.startTime.toLocaleString('en-GB', {
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: 'short',
            });
        },
        eventDates(): string {
            const startDate = this.schoolEvent.startTime;
            const endDate = this.schoolEvent.endTime;
            const startYearFormat =
                startDate.getFullYear() !== endDate.getFullYear() ? 'numeric' : undefined;
            const startMonthFormat =
                startDate.getMonth() !== endDate.getMonth() ? 'long' : undefined;

            const start = startDate.toLocaleDateString('en-GB', {
                month: startMonthFormat,
                day: 'numeric',
                year: startYearFormat,
            });
            const end = endDate.toLocaleDateString('en-GB', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
            const startTime = startDate.toLocaleTimeString('en-GB', {
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: 'short',
            });
            return `${start} - ${end}, ${startTime}`;
        },
        privacy(): { label: string; icon: string } {
            switch (this.schoolEvent.privacy) {
                case 'open':
                    return {
                        label: this.$t('schoolevents.privacy.open').toString(),
                        icon: 'lock-open',
                    };
                case 'private':
                    return {
                        label: this.$t('schoolevents.privacy.private').toString(),
                        icon: 'lock',
                    };
                case 'invite':
                    return {
                        label: this.$t('schoolevents.privacy.invite').toString(),
                        icon: 'lock',
                    };
                default:
                    return {
                        label: this.$t('schoolevents.privacy.open').toString(),
                        icon: 'lock',
                    };
            }
        },
        isRegistered(): boolean {
            return this.mySchoolEvents.some(e => {
                return e.schoolEventId === this.schoolEvent.schoolEventId && e.registered;
            });
        },
        spotsLeft(): number {
            const nullish = (value: number | null | undefined): value is null | undefined =>
                value === null || value === undefined;

            const numSpots = this.schoolEvent.numberOfSpots || null;
            if (nullish(numSpots) || nullish(this.schoolEvent.signupCount)) return Infinity;

            return Math.max(0, numSpots - this.schoolEvent.signupCount);
        },
    },
    methods: {
        load() {
            if (!this.schoolEventId) return;

            Promise.all([
                this.service.getSchoolEvent(this.schoolEventId),
                this.service.getMySchoolEvents(),
            ])
                .then(([schoolEvent, mySchoolEvents]) => {
                    this.schoolEvent = schoolEvent;
                    this.mySchoolEvents = mySchoolEvents;
                })
                .catch(err => {
                    console.error(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async handleRegister() {
            this.service
                .createSignup(this.schoolEvent.schoolEventId!)
                .then(() => {
                    this.load();
                    this.showRegisteredModal = true;
                })
                .catch(err => {
                    const error = Array.isArray(err.response.data) ? err.response.data[0] : null;
                    if (!!error && error.code === 'NoSpotsLeft') window.alert('No spots left');
                });
        },
        handleCloseModal() {
            this.showRegisteredModal = false;
        },
        async handleDeleteSignup() {
            const response = await this.service.deleteSignup(this.schoolEvent.schoolEventId!);
            if (response.status === 200 || response.status === 204) {
                this.load();
                this.showRegisteredModal = false;
            }
        },
        convertDate(date: Date | string): string {
            let event = new Date(date).toISOString();
            let [day, time] = event.split('T');
            day = day.split('-').join('');
            time = time
                .split(':')
                .join('')
                .replace('.000Z', 'Z');
            return `${day}T${time}`;
        },
        handleAddToCalendar() {
            const calendar =
                'BEGIN:VCALENDAR\n' +
                'VERSION:2.0\n' +
                'PRODID:-//Test Cal//EN\n' +
                'BEGIN:VEVENT\n' +
                'UID:uid1@highered.global\n' +
                'DTSTAMP:' +
                this.convertDate(new Date()) +
                'ORGANIZER;CN=Highered Global:mailto:info@highered.global\n' +
                'DTSTART:' +
                this.convertDate(this.schoolEvent.startTime) +
                '\n' +
                'DTEND:' +
                this.convertDate(this.schoolEvent.endTime) +
                '\n' +
                'SUMMARY:' +
                this.schoolEvent.title +
                '\n' +
                'DESCRIPTION:' +
                this.schoolEvent.description +
                '\n' +
                'END:VEVENT\n' +
                'END:VCALENDAR';

            const blob = new Blob([calendar], { type: 'text/calendar;charset=utf-8' });
            window.open(URL.createObjectURL(blob));
        },
    },
    mounted() {
        this.schoolEventId = this.$route.params.id;
        this.load();
    },
});
